export default "https://cdn-shared.mathletics.com/teacher-modules/mx-portal/278/assets/images/stars-0116e850d6678072b771967e4d4fb5d1.svg";